import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { SelectedFieldEnum } from 'app/interfaces/fields.dto';

@Pipe({
  name: 'translateField'
})
export class TranslateFieldPipe implements PipeTransform {
  constructor(private globalService: GlobalService){}
  transform(selected_field: SelectedFieldEnum): string {
    return this.globalService.getFieldNameByType(selected_field);
  }
}
